import React from 'react';
import { RefreshCw } from 'lucide-react';
import { logError } from './helpers';

// BUG-09: the app had zero error boundaries, so any throw during render
// unmounted the whole tree and left a white screen — a malformed T12
// spreadsheet was enough to do it to the investor portal.
//
// Deliberately a class component: componentDidCatch/getDerivedStateFromError
// have no hook equivalent, so this is the one place a class is required.
// No new dependency — the icon is lucide-react, already used throughout.
//
// Mounted at two roots:
//   index.js  — outside <MsalProvider>, the catch-all for the staff app
//               (CRM, Document Manager and the public /sign page all render
//               under it).
//   App.js    — around <InvestorDashboard>, so a portal crash is contained
//               there and shows the portal's own message instead of taking
//               the outer boundary and the rest of the tree with it.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    // SEC-25 discipline: logError pulls out err.message (and an HTTP status
    // if there is one) and hands the console a string. The second argument
    // React passes here, errorInfo, is deliberately dropped — the rule is
    // that we choose what reaches the console, not that we trust this
    // particular object.
    logError('Unhandled render error (ErrorBoundary):', error);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="crm-login">
        <div className="crm-login__card">
          <div className="crm-login__logo">
            <img src="/cagan-logo.png" alt="Cagan Logo" className="crm-login__logo-img" />
          </div>
          <h1 className="crm-login__title">Something went wrong</h1>
          <p className="crm-login__subtitle">
            {this.props.message
              || 'This page ran into an unexpected problem. Reloading usually fixes it. If it keeps happening, please contact your administrator.'}
          </p>
          <div className="crm-login__divider" />
          <button
            type="button"
            className="crm-login__btn crm-login__btn--admin"
            onClick={this.handleReload}
          >
            <RefreshCw size={18} />
            Reload this page
          </button>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
